import React from 'react';
import { useApplication } from '../../context/ApplicationContext';
import FormField from '../FormField';
import SelectField from '../SelectField';

function EmploymentInfoStep() {
  const { state, dispatch } = useApplication();
  const { formData } = state;

  const handleChange = (field, value) => {
    dispatch({
      type: 'UPDATE_FORM_DATA',
      payload: { [field]: value }
    });
  };

  const occupationOptions = [
    { value: 'farmer', label: 'Farmer' },
    { value: 'trader', label: 'Trader' },
    { value: 'civil-servant', label: 'Civil Servant' },
    { value: 'teacher', label: 'Teacher' },
    { value: 'nurse', label: 'Nurse' },
    { value: 'doctor', label: 'Doctor' },
    { value: 'lawyer', label: 'Lawyer' },
    { value: 'engineer', label: 'Engineer' },
    { value: 'accountant', label: 'Accountant' },
    { value: 'business-owner', label: 'Business Owner' },
    { value: 'student', label: 'Student' },
    { value: 'retired', label: 'Retired' },
    { value: 'unemployed', label: 'Unemployed' },
    { value: 'other', label: 'Other' },
  ];

  const incomeRangeOptions = [
    { value: '0-500', label: 'Below GHS 500' },
    { value: '500-1000', label: 'GHS 500 - 1,000' },
    { value: '1000-2000', label: 'GHS 1,000 - 2,000' },
    { value: '2000-5000', label: 'GHS 2,000 - 5,000' },
    { value: '5000-10000', label: 'GHS 5,000 - 10,000' },
    { value: '10000+', label: 'Above GHS 10,000' },
  ];

  const sourceOfIncomeOptions = [
    { value: 'salary', label: 'Salary/Wages' },
    { value: 'business', label: 'Business Income' },
    { value: 'farming', label: 'Farming/Agriculture' },
    { value: 'investment', label: 'Investment Returns' },
    { value: 'pension', label: 'Pension' },
    { value: 'remittance', label: 'Remittances' },
    { value: 'other', label: 'Other' },
  ];

  return (
    <div className="space-y-6 w-full max-w-full overflow-x-hidden">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
        <SelectField
          label="Occupation"
          value={formData.occupation}
          onChange={(value) => handleChange('occupation', value)}
          options={occupationOptions}
          required
          fieldName="occupation"
        />
        <FormField
          label="Employer/Business Name"
          type="text"
          value={formData.employer}
          onChange={(value) => handleChange('employer', value)}
          required
          placeholder="Name of employer or your business"
          fieldName="employer"
        />
      </div>

      <FormField
        label="Work/Business Address"
        type="textarea"
        value={formData.workAddress}
        onChange={(value) => handleChange('workAddress', value)}
        required
        rows={3}
        placeholder="Complete address of your workplace or business location"
        fieldName="workAddress"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
        <SelectField
          label="Monthly Income Range"
          value={formData.monthlyIncome}
          onChange={(value) => handleChange('monthlyIncome', value)}
          options={incomeRangeOptions}
          required
          fieldName="monthlyIncome"
        />
        <SelectField
          label="Primary Source of Income"
          value={formData.sourceOfIncome}
          onChange={(value) => handleChange('sourceOfIncome', value)}
          options={sourceOfIncomeOptions}
          required
          fieldName="sourceOfIncome"
        />
      </div>

      {/* Next of Kin Section */}
      <div className="bg-gray-50 rounded-lg p-4 sm:p-6 mt-8 w-full">
        <h3 className="text-lg font-semibold text-agric-primary mb-4">Next of Kin Information</h3>
        <div className="space-y-4">
          <FormField
            label="Full Name"
            type="text"
            value={formData.nextOfKinName}
            onChange={(value) => handleChange('nextOfKinName', value)}
            required
            placeholder="Next of kin's full name"
            fieldName="nextOfKinName"
          />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
            <FormField
              label="Relationship"
              type="text"
              value={formData.nextOfKinRelationship}
              onChange={(value) => handleChange('nextOfKinRelationship', value)}
              required
              placeholder="e.g., Spouse, Parent, Sibling"
              fieldName="nextOfKinRelationship"
            />
            <FormField
              label="Phone Number"
              type="tel"
              value={formData.nextOfKinPhone}
              onChange={(value) => handleChange('nextOfKinPhone', value)}
              required
              placeholder="+233 XX XXX XXXX"
              fieldName="nextOfKinPhone"
            />
          </div>
          <FormField
            label="Address"
            type="textarea"
            value={formData.nextOfKinAddress}
            onChange={(value) => handleChange('nextOfKinAddress', value)}
            required
            rows={3}
            placeholder="Next of kin's complete address"
            fieldName="nextOfKinAddress"
          />
        </div>
      </div>

      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 w-full">
        <h4 className="font-medium text-yellow-900 mb-2">Employment Verification</h4>
        <p className="text-sm text-yellow-800">
          Your employment information may be verified as part of our account opening process. Please ensure all details are accurate and current.
        </p>
      </div>
    </div>
  );
}

export default EmploymentInfoStep;